export default class RegistrationState {
  constructor() {
    this.registration = {
      loading: false,
      data: {},
      error: null,
    };
    this.verification = {
      loading: false,
      data: null,
      error: null,
    };
    this.verificationResend = {
      loading: false,
      data: null,
      error: null,
    };
  }
}
